export default () => ({
  // Company Favorite
  companyFavoriteLoading: false,

  // Plugin Entities
  pluginEntities: {}
});
